import ValidatableObject from "../validation/ValidatableObject";
import Model from "../Model";
import { IFormSectionQualifier } from "./FormSectionQualifier";

export interface TFormSection {
  comment: string;
  id: number;
  label: string;
  labelVisible: boolean;
  level: number;
  maxNumber: number;
  orderNumber: number;
  orderNumberVisible: boolean;
  formSectionId: number;
  required: boolean;
  formTypeCode: string;
  portalAggregate: boolean;
}

export interface IFormSection extends TFormSection {
  qualifiers: IFormSectionQualifier[];
  subsections: IFormSection[];
}

const FormSection = Model(
  (model: TFormSection): IFormSection => {
    const _formSection: TFormSection = Object.assign({}, model);

    let create = (formSection: IFormSection): IFormSection => {
      let obj = ValidatableObject(formSection);
      return obj;
    };

    let _qualifiers: IFormSectionQualifier[] = [];

    let _subsections: IFormSection[] = [];

    let formSection = {
      get comment() {
        return _formSection.comment;
      },
      set comment(value) {
        _formSection.comment = value;
      },
      get id() {
        return _formSection.id;
      },
      set id(value) {
        _formSection.id = value;
      },
      get label() {
        return _formSection.label;
      },
      set label(value) {
        _formSection.label = value;
      },
      get labelVisible() {
        return _formSection.labelVisible;
      },
      set labelVisible(value) {
        _formSection.labelVisible = value;
      },
      get level() {
        return _formSection.level;
      },
      set level(value) {
        _formSection.level = value;
      },
      get maxNumber() {
        return _formSection.maxNumber;
      },
      set maxNumber(value) {
        _formSection.maxNumber = value;
      },
      get orderNumber() {
        return _formSection.orderNumber;
      },
      set orderNumber(value) {
        _formSection.orderNumber = value;
      },
      get orderNumberVisible() {
        return _formSection.orderNumberVisible;
      },
      set orderNumberVisible(value) {
        _formSection.orderNumberVisible = value;
      },
      get formSectionId() {
        return _formSection.formSectionId;
      },
      set formSectionId(value) {
        _formSection.formSectionId = value;
      },
      get qualifiers() {
        return _qualifiers;
      },
      set qualifiers(value) {
        _qualifiers = value;
      },
      get subsections() {
        return _subsections;
      },
      set subsections(value) {
        _subsections = value;
      },
      get required() {
        return _formSection.required;
      },
      set required(value) {
        _formSection.required = value;
      },
      get formTypeCode() {
        return _formSection.formTypeCode;
      },
      set formTypeCode(value) {
        _formSection.formTypeCode = value;
      },
      get portalAggregate(){
        return _formSection.portalAggregate;
      },
      set portalAggregate(value){
        _formSection.portalAggregate = value
      }
    };
    return create(formSection);
  }
);

export default FormSection;
